<app-hero
	[title]="'shoppingCart.title' | translate"
	imageDesktop="assets/hero/purchase-hero-3840x400.jpg"
	imageMobile="assets/hero/purchase-hero-768x180.jpg"
/>
<div class="container-xxl mh-500 pt-3">
	<section>
		@if (total) {
			<button
				type="button"
				class="btn btn-transparent btn-ico text-uppercase"
				[ngClass]="showSearch ? 'btn-ico-eye-struck-before' : 'btn-ico-filters-before'"
				(click)="toggleSearch()"
			>
				{{ (showSearch ? "auction.details.hideFilters" : "auction.details.filters") | translate }}
			</button>
			<div
				[collapse]="!showSearch"
				[isAnimated]="true"
			>
				<app-filters
					configuration="purchase"
					[singleLevel]="purchaseHistory"
					(singleLevelChange)="onSingleLevelChange($event.data, $event.filtersHaveChanged)"
				/>
			</div>
		} @else {
			<div>
				<p>{{ "vehicleList.noVehicleFound" | translate }}</p>
			</div>
		}
	</section>
	@if (rows.length) {
		<div
			[mfTableLength]="serverPaged ? total : null"
			[mfData]="rows"
			#mf="appDataTable"
			[mfSortBy]="tableData.orderBy"
			(mfSortByChange)="saveOrderBy($event)"
			[mfSortOrder]="tableData.sortOrder"
			(mfSortOrderChange)="saveSortOrder($event)"
			[mfActivePage]="initialPage"
			[mfRowsOnPage]="tableData.rowsOnPage"
			(onPageChange)="savePaging($event)"
			class="mt-4"
		>
			@let noFieldSelected = !tableData.orderBy;
			<article>
				<header class="purchase-summary-heading bg-white rounded-top-3 ck-fixed-shadow d-none mb-3 px-3 d-lg-grid">
					<!-- <div></div> -->
					<div class="py-1 min-width-0">
						@let showLogoTriangle = noFieldSelected || tableData.orderBy === "smallLogo";
						<app-default-sorter
							by="smallLogo"
							class="d-inline-block align-middle mw-100 position-relative text-truncate"
							[title]="'shoppingCart.template' | translate"
							[class.pe-4]="showLogoTriangle"
						>
							{{ "shoppingCart.template" | translate }}
							@if (showLogoTriangle) {
								<div
									class="position-absolute end-0 top-50 translate-middle-y triangle me-1"
									[ngClass]="'triangle-' + (tableData.sortOrder === 'asc' ? 'up' : 'down')"
								></div>
							}
						</app-default-sorter>
					</div>
					<div class="py-1 min-width-0">
						@let showBrandTriangle = noFieldSelected || tableData.orderBy === "brand";
						<app-default-sorter
							by="brand"
							class="d-inline-block align-middle mw-100 position-relative text-truncate"
							[title]="'auction.details.brand' | translate"
							[class.pe-4]="showBrandTriangle"
						>
							{{ "auction.details.brand" | translate }}
							@if (showBrandTriangle) {
								<div
									class="position-absolute end-0 top-50 translate-middle-y triangle me-1"
									[ngClass]="'triangle-' + (tableData.sortOrder === 'asc' ? 'up' : 'down')"
								></div>
							}
						</app-default-sorter>
					</div>
					<div class="py-1 min-width-0">
						@let showModelTriangle = noFieldSelected || tableData.orderBy === "model";
						<app-default-sorter
							by="model"
							class="d-inline-block align-middle mw-100 position-relative text-truncate"
							[title]="'auction.details.model' | translate"
							[class.pe-4]="showModelTriangle"
						>
							{{ "auction.details.model" | translate }}
							@if (showModelTriangle) {
								<div
									class="position-absolute end-0 top-50 translate-middle-y triangle me-1"
									[ngClass]="'triangle-' + (tableData.sortOrder === 'asc' ? 'up' : 'down')"
								></div>
							}
						</app-default-sorter>
					</div>
					<div class="py-1 min-width-0">
						@let showChannelTriangle = noFieldSelected || tableData.orderBy === "channel";
						<app-default-sorter
							by="channel"
							class="d-inline-block align-middle mw-100 position-relative text-truncate"
							[title]="'shoppingCart.channel' | translate"
							[class.pe-4]="showChannelTriangle"
						>
							{{ "shoppingCart.channel" | translate }}
							@if (showChannelTriangle) {
								<div
									class="position-absolute end-0 top-50 translate-middle-y triangle me-1"
									[ngClass]="'triangle-' + (tableData.sortOrder === 'asc' ? 'up' : 'down')"
								></div>
							}
						</app-default-sorter>
					</div>
					<div class="py-1 min-width-0">
						@let showDateTriangle = noFieldSelected || tableData.orderBy === "datePurchase";
						<app-default-sorter
							by="datePurchase"
							class="d-inline-block align-middle mw-100 position-relative text-truncate"
							[title]="'shoppingCart.date' | translate"
							[class.pe-4]="showDateTriangle"
						>
							{{ "shoppingCart.date" | translate }}
							@if (showDateTriangle) {
								<div
									class="position-absolute end-0 top-50 translate-middle-y triangle me-1"
									[ngClass]="'triangle-' + (tableData.sortOrder === 'asc' ? 'up' : 'down')"
								></div>
							}
						</app-default-sorter>
					</div>
					<div class="py-1 min-width-0">
						@let showPriceTriangle = noFieldSelected || tableData.orderBy === "price";
						<app-default-sorter
							by="price"
							class="d-inline-block align-middle mw-100 position-relative text-truncate"
							[title]="'shoppingCart.price' | translate"
							[class.pe-4]="showPriceTriangle"
						>
							{{ "shoppingCart.price" | translate }}
							@if (showPriceTriangle) {
								<div
									class="position-absolute end-0 top-50 translate-middle-y triangle me-1"
									[ngClass]="'triangle-' + (tableData.sortOrder === 'asc' ? 'up' : 'down')"
								></div>
							}
						</app-default-sorter>
					</div>
				</header>
				<ul class="p-0 m-0">
					@for (element of mf.data; track element.idVehicle) {
						<li class="py-1">
							<!-- TODO: dovrebbe andare in blank -->
							<a
								[routerLink]="['/', ClickarPath.PRIVATE, ClickarPath.VEHICLE_MANAGEMENT, ClickarPath.VEHICLE_DETAILS, { idVehicle: element.idVehicle }]"
								class="purchase-summary-item text-gray bg-white rounded-3 ck-shadow p-3"
							>
								<!-- <div class="auction-image pe-lg-3">
									TODO: Image
									@if (utils.isEmpty(element?.appraisalCode)) {
										@if (utils.isEmpty(element?.idPrincipalPhoto)) {
											<div class="icon no-foto ar-43"></div>
										} @else {
											<img
												loading="lazy"
												class="vehicleImg"
												[src]="utils.getImageUrl(element.idPrincipalPhoto)"
											/>
										}
									} @else {
										<button
											type="button"
											class="btn p-0 w-100"
											(click)="$event.preventDefault(); $event.stopPropagation(); openURL(element.imagesUrl)"
										>
											<img
												loading="lazy"
												class="vehicleImg"
												alt=""
												[src]="element.imageUrl || wcmService.noPhotoUrl"
											/>
										</button>
									}
								</div> -->
								<div class="auction-vendor-logo text-truncate py-lg-3 pe-lg-2">
									<span
										class="d-lg-none"
										title="{{ 'auction.details.auctioneer' | translate }}: {{ element.businessName }}"
									>
										{{ "auction.details.auctioneer" | translate }}: {{ element.businessName }}
									</span>
									<span class="d-none d-lg-inline">
										@if (!utils.isNullOrUndefined(element?.smallLogo)) {
											<button
												type="button"
												class="btn-noborder w-100"
												(click)="$event.preventDefault(); $event.stopPropagation(); goToPresentation(element.idTemplate)"
											>
												<img
													loading="lazy"
													[alt]="element.businessName"
													[title]="element.businessName"
													[src]="utils.getImageUrl(element.smallLogo)"
												/>
											</button>
										}
										@if (element?.channel === Channel.SHOWCASE) {
											<img
												loading="lazy"
												[alt]="element.businessName"
												[title]="element.businessName"
												[src]="wcmService.logoUrl"
											/>
										}
									</span>
								</div>
								<div
									class="auction-brand text-truncate py-lg-3 text-center text-xxl text-lg-base text-lg-start"
									[title]="element.brand ?? ''"
								>
									<strong class="text-blue">{{ element.brand ?? "&nbsp;" }}</strong>
								</div>
								<div
									class="auction-model text-truncate pb-3 pt-lg-3 text-center text-xl text-lg-base text-lg-start"
									[title]="element.model ?? ''"
								>
									<strong>{{ element.model ?? "&nbsp;" }}</strong>
								</div>
								<div class="auction-tag py-3 mt-3 mt-lg-0">
									<span
										class="ck-badge text-uppercase"
										[attr.data-color]="element.channel === Channel.AUCTION ? 'lightblue' : 'blue'"
									>
										{{ (element.channel === Channel.AUCTION ? "auction.auctions.auction" : "menu.showcase") | translate }}
									</span>
								</div>
								<div class="auction-offer-date text-center text-lg-start pt-3 pb-2 pb-lg-3">
									<span>
										{{ element.datePurchase | ckDate }}
										<!-- {{element.datePurchase | ckDate: false:false:false:false:true}} -->
									</span>
								</div>
								<div class="auction-offer text-center py-3 text-lg-start">
									<strong class="text-huge text-blue text-lg-xl">
										{{ Math.floor(element.price) | number: "1.0-0" : "it-IT" }} {{ getCurrencySymbol(element.currency ?? "EUR", "narrow") }}
									</strong>
								</div>
								<div class="auction-cardetails py-3 pt-lg-3 pb-lg-0 border-top-lg-gray">
									<strong>{{ "auction.details.version" | translate }}</strong
									>: {{ element.version }}
									<br />
									<strong>{{ "shoppingCart.licensePlate" | translate }}</strong
									>: {{ element.licensePlate }}
								</div>
								<div
									class="auction-buttons pt-3 border-top-gray cursor-default"
									(click)="$event.preventDefault(); $event.stopPropagation()"
								>
									@if (element?.channel !== Channel.SHOWCASE) {
										<div class="d-flex flex-column gap-3 flex-lg-row justify-content-lg-end align-items-lg-center">
											@if (utils.isNullOrUndefined(element.idFeedback)) {
												<button
													type="button"
													class="btn btn-outline btn-ico btn-ico-star-after text-uppercase"
													(click)="$event.preventDefault(); $event.stopPropagation(); vote(element)"
												>
													{{ "shoppingCart.vote" | translate }}
												</button>
											}
											<!-- @else {
												@if (element.idFeedback == -1) {
													<div></div>
												} @else {
													<star-rating
														[showHalfStars]="false"
														starType="svg"
														size="medium"
														staticColor="ok"
														[numOfStars]="5"
														[rating]="element.rating"
														[readOnly]="true"
													>
													</star-rating>
												}
											}
											-->
											<button
												type="button"
												class="btn btn-outline btn-ico btn-ico-mail-after text-uppercase"
												(click)="$event.preventDefault(); $event.stopPropagation(); awardEmail(element)"
											>
												{{ "shoppingCart.awardEmail" | translate }}
											</button>
											@if (element?.flgPaid) {
												<div
													class="btn btn-transparent btn-ico btn-ico-pay-after text-uppercase"
													[style]="{ color: '#005135', cursor: 'default' }"
												>
													{{ "shoppingCart.paid" | translate }}
												</div>
											} @else if (element?.flgOnlinePayment) {
												<button
													type="button"
													class="btn btn-blue btn-ico btn-ico-pay-after text-uppercase"
													(click)="$event.preventDefault(); $event.stopPropagation(); payByLink(element)"
												>
													{{ "shoppingCart.payOnline" | translate }}
												</button>
											}
										</div>
									}
									@if (market === "IT" && element.businessName?.toLowerCase().includes("leasys")) {
										<div class="text-center text-lg-end pt-2">
											<a
												routerLink="/private/post-sales"
												class="ck-link"
											>
												{{ "shoppingCart.afterSalesInfo" | translate }}
											</a>
										</div>
									}
								</div>
							</a>
						</li>
					}
				</ul>
			</article>
			<div class="text-center py-3">
				<app-bootstrap-paginator [rowsOnPageSet]="rowsOnPageSet" />
			</div>
		</div>
	}
</div>